import React from "react";
import {
  Button,
  Space,
} from "antd";
import {
  SyncOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import AppBreadcrumb from "GlobalComponents/AppBreadcrumb";

const Navbar = ({  onNuevo,onReload }) => {
  return (<>
    <Space align="center" style={{ marginRight: "auto" }}>
      <AppBreadcrumb items={[{ label: "Configuraciones", path: "/" }, { label: "Refrigerantes" }]} backTo="/" />
    </Space>
    <Space style={{ marginLeft: 16 }}>
      <Button
          type="link"
          icon={<PlusOutlined />}
          onClick={onNuevo} style={{color:'whitesmoke'}}
        >Nuevo</Button>

      <Button
          type="link"
          icon={<SyncOutlined />}
          onClick={onReload} style={{color:'whitesmoke'}}
        >Recargar</Button>
    </Space>
    </>
  );
};

export default Navbar;
